import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { formatCurrency } from '@/lib/utils';

interface SubscriptionTimelineProps {
  history: Array<{
    year: string;
    value: number;
    sensors: number;
  }>;
}

export default function SubscriptionTimeline({ history }: SubscriptionTimelineProps) {
  if (history.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Subscription Timeline</CardTitle>
          <CardDescription>Historical subscription data</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">No subscription history available</p>
        </CardContent>
      </Card>
    );
  }

  const maxValue = Math.max(...history.map((h) => h.value));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Subscription Timeline</CardTitle>
        <CardDescription>Revenue growth over time</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {history.map((item, index) => {
            const widthPercent = maxValue > 0 ? (item.value / maxValue) * 100 : 0;
            const isLast = index === history.length - 1;

            return (
              <div key={item.year} className="space-y-1">
                <div className="flex items-center justify-between text-sm">
                  <span className="font-medium">
                    {item.year}
                    {isLast && (
                      <span className="ml-2 text-xs text-primary">Current</span>
                    )}
                  </span>
                  <span className="text-muted-foreground">
                    {formatCurrency(item.value)}
                  </span>
                </div>
                <div className="h-2 w-full overflow-hidden rounded-full bg-secondary">
                  <div
                    className="h-full rounded-full bg-primary transition-all"
                    style={{ width: `${widthPercent}%` }}
                  />
                </div>
                <p className="text-xs text-muted-foreground">
                  {item.sensors} sensors
                </p>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
